module.exports = __webpack_public_path__ + "img/level_four_lock.535b2643.png";